module.exports = __webpack_public_path__ + "static/media/practice_ranking_inactive.65292446.svg";